var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "attachments-section m-b-30" }, [
    _c("h6", { staticClass: "title" }, [_vm._v("Attachments")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show_attach_modal,
                expression: "show_attach_modal"
              }
            ],
            staticClass: "modal-attach-preview"
          },
          [
            _c(
              "div",
              {
                staticClass: "content",
                class: {
                  by_width: _vm.attach_by_width,
                  hideIn: _vm.attach_hideIn
                }
              },
              [
                _c("div", {
                  staticClass: "fa fa-times",
                  on: { click: _vm.close_modal }
                }),
                _vm._v(" "),
                _vm.media_attachments.length > 1
                  ? _c("div", {
                      staticClass: "fa fa-chevron-left",
                      on: {
                        click: function($event) {
                          return _vm.switch_media_attach("prew")
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.media_attachments.length > 1
                  ? _c("div", {
                      staticClass: "fa fa-chevron-right",
                      on: {
                        click: function($event) {
                          return _vm.switch_media_attach()
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedAttach.type === "image"
                  ? _c("img", {
                      staticClass: "file-preview",
                      attrs: { src: _vm.selectedAttach.url }
                    })
                  : _vm.selectedAttach.type === "video"
                  ? _c("video", {
                      staticClass: "file-preview",
                      attrs: { src: _vm.selectedAttach.url, controls: "" }
                    })
                  : _vm._e()
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.attachments, function(attach) {
          return _c(
            "div",
            { staticClass: "col-xl-3 col-lg-4 col-md-6 m-b-10" },
            [
              _c(
                "div",
                {
                  staticClass: "attach-file-wrap",
                  attrs: { id: "file-" + attach.id }
                },
                [
                  _c("div", { staticClass: "file-thumbnail available" }, [
                    attach.type === "image"
                      ? _c("img", {
                          staticClass: "file-preview",
                          attrs: { src: attach.url },
                          on: {
                            click: function($event) {
                              return _vm.open_in_modal(attach)
                            }
                          }
                        })
                      : attach.type === "video"
                      ? _c(
                          "div",
                          {
                            staticClass: "file-preview video-attach",
                            on: {
                              click: function($event) {
                                return _vm.open_in_modal(attach)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-play-circle" }),
                            _vm._v(" "),
                            _c("video", {
                              staticClass: "file-preview",
                              attrs: { src: attach.url }
                            })
                          ]
                        )
                      : _vm.has_access
                      ? _c(
                          "a",
                          {
                            staticClass: "file-preview",
                            attrs: { href: attach.url, target: "_blank" }
                          },
                          [_vm._v(_vm._s(_vm.fileExtensionUp(attach)))]
                        )
                      : _c("a", { staticClass: "file-preview" }, [
                          _vm._v(_vm._s(_vm.fileExtensionUp(attach)))
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "file-name" }, [
                    _vm._v(_vm._s(attach.name))
                  ])
                ]
              )
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }